import { render, staticRenderFns } from "./WorkerSidebarNew.vue?vue&type=template&id=4cb90262&scoped=true"
import script from "./WorkerSidebarNew.vue?vue&type=script&lang=ts"
export * from "./WorkerSidebarNew.vue?vue&type=script&lang=ts"
import style0 from "./WorkerSidebarNew.vue?vue&type=style&index=0&id=4cb90262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb90262",
  null
  
)

export default component.exports